<!-- page Header -->
<section class="lead-hero curve -bottom -white">
    <span class="photo"></span>
    <div class="intro">
        <div class="container">
            <!-- click back -->
            <div class="flow">
                <a [routerLink]="['/fund']">
                    <i class="icon icon-arrow-back"></i>
                    <span class="text">{{language.backfund}}</span>
                </a>
            </div>

            <!-- header title -->
            <div class="row no-gutter">
                <div class="col-xl-7">
                    <h1 *ngIf="!isTrust" class="title">{{fundNameTh}} {{fundCode}}</h1>
                    <h1 *ngIf="isTrust" class="title">{{fundNameTh}} ({{fundCode}})</h1>
                    <!-- <h1 class="title">{{fundNameTh}} {{fundCode}}</h1> -->
                    <section class="risk-detail">
                        <ul class="list list-unstyled list-inline">
                            <li>
                                <span class="group">
                                    <span class="thumb">
                                        <img *ngIf="riskSpectrum === '1'" src="../../../assets/images/risk/level-1@2x.png"
                                            class="img-responsive" alt="level 1">
                                        <img *ngIf="riskSpectrum === '2'" src="../../../assets/images/risk/level-2@2x.png"
                                            class="img-responsive" alt="level 2">
                                        <img *ngIf="riskSpectrum === '3'" src="../../../assets/images/risk/level-3@2x.png"
                                            class="img-responsive" alt="level 3">
                                        <img *ngIf="riskSpectrum === '4'" src="../../../assets/images/risk/level-4@2x.png"
                                            class="img-responsive" alt="level 4">
                                        <img *ngIf="riskSpectrum === '5'" src="../../../assets/images/risk/level-5@2x.png"
                                            class="img-responsive" alt="level 5">
                                        <img *ngIf="riskSpectrum === '6'" src="../../../assets/images/risk/level-6@2x.png"
                                            class="img-responsive" alt="level 6">
                                        <img *ngIf="riskSpectrum === '7'" src="../../../assets/images/risk/level-7@2x.png"
                                            class="img-responsive" alt="level 7">
                                        <ng-container *ngIf="typeFund != 16">
                                            <img *ngIf="riskSpectrum === '8'"
                                                src="../../../assets/images/risk/level-8@2x.png" class="img-responsive"
                                                alt="level 8">
                                        </ng-container>
                                        <img *ngIf="riskSpectrum === '8+'" src="../../../assets/images/risk/level-8plus@2x.png" class="img-responsive" alt="level 8+">
                                    </span>
                                    <!-- <ng-container *ngIf="(fundCode != 'GAHREIT') && (riskSpectrum !== '8')"> -->
                                    <ng-container *ngIf="(typeFund != 16)">
                                        <span class="text">{{riskSpectrumName}}
                                            <br>
                                        </span>
                                    </ng-container>
                                </span>
                            </li>
                            <li *ngIf="IsFlagMorning == 'y' ">
                                <span class="group -morning">
                                    <span class="thumb"></span>
                                    <span class="text">
                                        {{MorningStarLevel}} {{language.funddetailthmorning1}}
                                        <time>{{language.funddetailthmorning2}} {{MorningStarDate}} </time>
                                    </span>
                                </span>
                            </li>
                        </ul>
                    </section>
                </div>
                <div class="col-xl-5 text-right -lg">
                    <ul class="list-unstyled list-inline list-feature">
                        <li>
                            <app-favorite-button [fundid]="FunbId" [curr]="currency" [inCard]="false">
                            </app-favorite-button>
                        </li>
                        <li>
                            <a [routerLink]="['/fund/compare']" routerLinkActive="router-link-active"
                                class="btn btn-primary -bg-white">{{language.funddetailthheaderbtn1}}</a>
                        </li>
                        <li>
                            <a href="https://onelive.one-asset.com/Home" target="_blank"
                                class="btn btn-primary -brand -short">
                                <i class="icon icon-cart"></i> {{language.funddetailthheaderbtn2}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- page Header -->
<!-- page Content -->
<section class="content-inner">

    <div *ngIf="!isETF && !isTrust" class="container">
        <section class="section-select -menu  d-block d-lg-none">
            <app-dropdown [title]="tabtitle" [valueDropdown]="valueDropdown" (selected)="selectValue($event)">
            </app-dropdown>
        </section>
        <div class="tab-listing d-none d-lg-block">

            <ul class="nav nav-tabs ">
                <li class="nav-item">
                    <a class="nav-link active" id="one-tab" data-toggle="tab" href="#one" role="tab" aria-controls="one"
                        aria-selected="true" (click)="selectValue(1)">
                        {{language.funddetailthmenu1}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link " id="two-tab" data-toggle="tab" href="#two" role="tab" aria-controls="two"
                        aria-selected="false" (click)="selectValue(2)">
                        {{language.funddetailthmenu2}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link " id="three-tab" data-toggle="tab" href="#three" role="tab" aria-controls="three"
                        aria-selected="false" (click)="selectValue(3)">
                        {{language.funddetailthmenu3}}
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <div *ngIf="isTrust && !isETF" class="container">
        <section class="section-select -menu  d-block d-lg-none">
            <app-dropdown [title]="tabtitle" [valueDropdown]="valueDropdown" (selected)="selectValue($event)">
            </app-dropdown>
        </section>
        <div class="tab-listing d-none d-lg-block">

            <ul class="nav nav-tabs ">
                <li class="nav-item">
                    <a class="nav-link active" id="one-tab" data-toggle="tab" href="#one" role="tab" aria-controls="one"
                        aria-selected="true" (click)="selectValue(1)">
                        {{language.funddetailthmenu4}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link " id="two-tab" data-toggle="tab" href="#two" role="tab" aria-controls="two"
                        aria-selected="false" (click)="selectValue(2)">
                        {{language.funddetailthmenu5}}
                    </a>
                </li>
                <li class="nav-item">
                    <a *ngIf="isTrust" class="nav-link " id="three-tab" data-toggle="tab" href="#three" role="tab"
                        aria-controls="three" aria-selected="false" (click)="selectValue(3)">
                        {{language.funddetailthmenu35}}
                    </a>

                    <a *ngIf="!isTrust" class="nav-link " id="three-tab" data-toggle="tab" href="#three" role="tab"
                        aria-controls="three" aria-selected="false" (click)="selectValue(3)">
                        {{language.funddetailthmenu6}}
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <div *ngIf="isETF" class="container">
        <section class="section-select -menu  d-block d-lg-none">
            <app-dropdown [title]="tabtitle" [valueDropdown]="etfvalueDropdown" (selected)="selectValue($event)">
            </app-dropdown>
        </section>
        <div class="tab-listing d-none d-lg-block ">

            <ul class="nav nav-tabs ">
                <li class="nav-item">
                    <a class="nav-link active" id="one-tab" data-toggle="tab" href="#one" role="tab" aria-controls="one"
                        aria-selected="true" (click)="selectValue(1)">
                        {{language.funddetailthmenu7}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link " id="two-tab" data-toggle="tab" href="#two" role="tab" aria-controls="two"
                        aria-selected="false" (click)="selectValue(2)">
                        {{language.funddetailthmenu8}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link " id="three-tab" data-toggle="tab" href="#three" role="tab" aria-controls="three"
                        aria-selected="false" (click)="selectValue(3)">
                        {{language.funddetailthmenu9}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link " id="four-tab" data-toggle="tab" href="#four" role="tab" aria-controls="four"
                        aria-selected="false" (click)="selectValue(4)">
                        {{language.funddetailthmenu10}}
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <div class="tab-content" id="myTabContent">
        <div [ngSwitch]="choiceFromSelect">
            <div *ngSwitchCase="'รายละเอียดกองทุน'" class="tab-pane fade show active" id="one" role="tabpanel"
                aria-labelledby="one-tab">
                <section class="fund-detail">
                    <div class="container">
                        <div class="row">

                            <div class="col-lg-6 col-xl-5" *ngIf="!isTrust && !isProp">
                                <section class="info">
                                    <section class="wrapper">
                                        <header>
                                            <h2 class="topic-title">
                                                <span rel="border-circle">
                                                    <i class="icon icon-price"></i>
                                                </span>
                                                <span class="text">
                                                    {{language.funddetailthm1b1detail1}} ({{currency}})
                                                    <span class="day">{{language.funddetailthm1b1detail2}}
                                                        {{fundDate}}</span>
                                                </span>
                                            </h2>
                                        </header>
                                        <section class="widget -stock">
                                            <div class="value">
                                                <span class="number">{{navPublish | number : '1.4-4'}}</span>
                                                <span class="index {{isPositive(navDiff) ? 'up' : 'down'}}">
                                                    <i
                                                        [ngClass]="(isPositive(navDiff))?'icon icon-arrow-index':'icon icon-arrow-index-down'"></i>
                                                    <span>
                                                        {{showOnlyValue(navDiff)}}
                                                        <small>({{showOnlyValue(navDiffPercentage) }}%)</small>
                                                    </span>
                                                </span>
                                            </div>
                                        </section>
                                        <ul class="list list-value list-unstyled">
                                            <li>
                                                <span class="text">{{language.funddetailthm1b1detail3}}</span>
                                                <div *ngIf="bid != 0 ; else isZeroBid">
                                                    <span class="number text-right -sm">{{bid | number : '1.4-4'}}</span>
                                                </div>
                                                <ng-template #isZeroBid>
                                                    <span class="number text-right -sm">-</span>
                                                </ng-template>
                                                
                                            </li>
                                            <li>
                                                <span class="text">{{language.funddetailthm1b1detail4}}</span>
                                                <div *ngIf="offer != 0 ; else isZeroOffer">
                                                    <span class="number text-right -sm">{{offer | number : '1.4-4'}}</span>
                                                </div>
                                                <ng-template #isZeroOffer>
                                                    <span class="number text-right -sm">-</span>
                                                </ng-template>
                                            </li>
                                            <li>
                                                <span class="text">{{language.funddetailthm1b1detail5}}</span>
                                                <span class="number text-right -sm">{{netAsset | number :
                                                    '1.2-2'}}</span>
                                            </li>
                                            <li *ngIf="typeFund == 16 || typeFund == 15">
                                                <span class="text">{{language.funddetailthm1b1detail6}}</span>
                                                <span class="number text-right -sm">{{totalAsset | number :
                                                    '1.2-2'}}</span>
                                            </li>
                                            <li *ngIf="fundCode == 'ONE-COMPLEX1YA'">
                                                <span class="text">*มูลค่า ณ วันสิ้นสุดโครงการ
                                                    โดยไม่รวมมูลค่าการลงทุนในตราสารหนี้ บมจ.การบินไทย</span>
                                            </li>
                                        </ul>
                                    </section>
                                    <div class="group-section -devided">
                                        <section>
                                            <header>
                                                <h2 class="topic-title">
                                                    <span rel="border-circle">
                                                        <i class="icon icon-devided"></i>
                                                    </span>
                                                    <span class="text">{{language.funddetailthm1b2detail1}}</span>
                                                </h2>
                                            </header>
                                            <p class="p-2">{{divenPolicy}}</p>
                                        </section>
                                    </div>
                                </section>
                            </div>

                            <div class="col-12" *ngIf="isTrust">
                                <section class="info">
                                    <section class="wrapper col-5">
                                        <header>
                                            <h2 class="topic-title">
                                                <span rel="border-circle">
                                                    <i class="icon icon-price"></i>
                                                </span>
                                                <span class="text">
                                                    {{language.funddetailthm1b1detail7}} ({{currency}})
                                                    <span class="day">{{language.funddetailthm1b1detail8}}
                                                        {{fundDate}}</span>
                                                </span>
                                            </h2>
                                        </header>
                                        <section class="widget -stock">
                                            <div class="value">
                                                <span class="number">{{navPublish | number : '1.4-4'}}</span>
                                                <span class="index {{isPositive(navDiff) ? 'up' : 'down'}}">
                                                    <i
                                                        [ngClass]="(isPositive(navDiff))?'icon icon-arrow-index':'icon icon-arrow-index-down'"></i>
                                                    <span>
                                                        {{showOnlyValue(navDiff)}}
                                                        <small>({{showOnlyValue(navDiffPercentage) }}%)</small>
                                                    </span>
                                                </span>
                                            </div>
                                        </section>
                                        <ul class="list list-value list-unstyled">
                                            <li>
                                                <span class="text">{{language.funddetailthm1b1detail9}}</span>
                                                <span class="number text-right -sm">{{netAsset | number :
                                                    '1.2-2'}}</span>
                                            </li>
                                            <li *ngIf="typeFund == 16 || typeFund == 15">
                                                <span class="text">{{language.funddetailthm1b1detail10}}</span>
                                                <span class="number text-right -sm">{{totalAsset | number :
                                                    '1.2-2'}}</span>
                                            </li>
                                        </ul>
                                    </section>
                                    <div class="group-section -devided">
                                        <section>
                                            <header>
                                                <h2 class="topic-title">
                                                    <span rel="border-circle">
                                                        <i class="icon icon-devided"></i>
                                                    </span>
                                                    <span class="text">{{language.funddetailthm1b2detail2}}</span>
                                                </h2>
                                            </header>
                                            <p class="p-2">{{divenPolicy}}</p>
                                        </section>
                                    </div>
                                </section>
                            </div>

                            <div class="col-12" *ngIf="isProp">
                                <section class="info">
                                    <section class="wrapper col-5">
                                        <header>
                                            <h2 class="topic-title">
                                                <span rel="border-circle">
                                                    <i class="icon icon-price"></i>
                                                </span>
                                                <span class="text">
                                                    {{language.funddetailthm1b1detail11}} ({{currency}})
                                                    <span class="day">{{language.funddetailthm1b1detail12}}
                                                        {{fundDate}}</span>
                                                </span>
                                            </h2>
                                        </header>
                                        <section class="widget -stock">
                                            <div class="value">
                                                <span class="number">{{navPublish | number : '1.4-4'}}</span>
                                                <span class="index {{isPositive(navDiff) ? 'up' : 'down'}}">
                                                    <i
                                                        [ngClass]="(isPositive(navDiff))?'icon icon-arrow-index':'icon icon-arrow-index-down'"></i>
                                                    <span>
                                                        {{showOnlyValue(navDiff)}}
                                                        <small>({{showOnlyValue(navDiffPercentage) }}%)</small>
                                                    </span>
                                                </span>
                                            </div>
                                        </section>
                                        <ul class="list list-value list-unstyled">
                                            <li>
                                                <span class="text">{{language.funddetailthm1b1detail13}}</span>
                                                <span class="number text-right -sm">{{netAsset | number :
                                                    '1.2-2'}}</span>
                                            </li>
                                            <li *ngIf="typeFund == 16 || typeFund == 15">
                                                <span class="text">{{language.funddetailthm1b1detail14}}</span>
                                                <span class="number text-right -sm">{{totalAsset | number :
                                                    '1.2-2'}}</span>
                                            </li>
                                        </ul>
                                    </section>
                                    <div class="group-section -devided">
                                        <section>
                                            <header>
                                                <h2 class="topic-title">
                                                    <span rel="border-circle">
                                                        <i class="icon icon-devided"></i>
                                                    </span>
                                                    <span class="text">{{language.funddetailthm1b2detail3}}</span>
                                                </h2>
                                            </header>
                                            <p class="p-2">{{divenPolicy}}</p>
                                        </section>
                                    </div>
                                </section>
                            </div>

                            <div class="col-lg-6 col-xl-7" *ngIf="!isTrust && !isProp">
                                <section class="info">
                                    <header>
                                        <h2 class="topic-title">
                                            <span rel="border-circle">
                                                <i class="icon icon-graph-stock"></i>
                                            </span>
                                            <span class="text">{{language.funddetailthm1b3detail1}}</span>
                                        </h2>
                                    </header>
                                    <div style="width: 100%;">
                                        <!-- <canvas baseChart [chartType]="'line'" [datasets]="lineChartData" [labels]="chartLabels"
                            [colors]="chartColors" [options]="chartOptions" [legend]="true">
                          </canvas> -->
                                        <div id="container" class="area-chart" [chart]="chart"></div>

                                    </div>
                                </section>
                            </div>
                        </div>

                        <div class="row" *ngIf="!isTrust && !isProp">
                            <div class="col-lg-6 col-xl-5">
                                <section class="group-section">
                                    <header>
                                        <h2 class="topic-title">
                                            <span rel="border-circle">
                                                <i class="icon icon-trophy"></i>
                                            </span>
                                            <span class="text">{{language.funddetailthm1b4detail1}}</span>
                                        </h2>
                                    </header>
                                    <div class="widget -award">
                                        <div class="photo" data-mh="award-photo">
                                            <p>{{cms_reward}}</p>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div class="col-lg-6 col-xl-7">
                                <section class="group-section">
                                    <header>
                                        <h2 class="topic-title">
                                            <span rel="border-circle">
                                                <i class="icon icon-goal"></i>
                                            </span>
                                            <span class="text">{{language.funddetailthm1b4detail2}}</span>
                                        </h2>
                                    </header>
                                    <div class="info">
                                        <h3 class="h6 f-semibold topic-title">{{language.funddetailthm1b4detail3}}</h3>
                                        <p class="p-2">{{cms_investment_stype}}</p>
                                    </div>
                                    <div class="info">
                                        <h3 class="h6 f-semibold topic-title">{{language.funddetailthm1b4detail4}}</h3>
                                        <p class="p-2">{{cms_investment_type}}</p>
                                    </div>
                                </section>
                            </div>
                        </div>

                    </div>
                </section>

                <section class="section-group -general curve -top">
                    <div class="container">
                        <header class="heading-title">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-data"></i>
                                </span>
                                <span class="text">{{language.funddetailthm1b5detail1}}</span>
                            </h2>
                        </header>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="info">
                                    <h3 *ngIf="isTrust" class="h6 topic-title">{{language.funddetailthm1b5detail2}}</h3>
                                    <h3 *ngIf="!isTrust" class="h6 topic-title">{{language.funddetailthm1b5detail3}}
                                    </h3>
                                    <P>{{typeName}}</P>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="info">
                                    <h3 *ngIf="isTrust" class="h6 topic-title">{{language.funddetailthm1b5detail14}}
                                    </h3>
                                    <h3 *ngIf="!isTrust" class="h6 topic-title">{{language.funddetailthm1b5detail4}}
                                    </h3>
                                    <div class="investment-policy" [innerHTML]="cms_investment_policy"></div>

                                    <!-- <p *ngIf="isbkkcp"><strong>ชื่อโครงการ : &nbsp;&nbsp;</strong> &nbsp;<br>
                                        1. &nbsp;อาคารชาญอิสสระ ทาวเวอร์ ถนนพระราม 4 เขตบางรัก กรุงเทพมหานคร
                                        จำนวนห้องชุด &nbsp;24 ยูนิต<br>
                                        2. &nbsp;อาคารชาญอิสสระ ทาวเวอร์ &nbsp;2 &nbsp;ถนนเพชรบุรีตัดใหม่ เขตบางกะปิ
                                        กรุงเทพมหานคร
                                        &nbsp;จำนวนห้องชุด 136 &nbsp;ยูนิต<br>
                                        <br>
                                        <strong>ประเภท :</strong> &nbsp;กรรมสิทธิ์ห้องชุดอาคารสำนักงานและพาณิชยกรรม<br>
                                        &nbsp;</p>

                                    <p *ngIf="ismipf"><strong>ชื่อโครงการ : </strong>&nbsp;&nbsp;อาคารมาลีนนท์ ทาวเวอร์
                                        &nbsp;ถนนพระราม 4
                                        &nbsp;เขตคลองเตย กรุงเทพมหานคร<br>
                                        <strong>ประเภท :</strong> &nbsp;กรรมสิทธิ์ที่ดินพร้อมอาคารสำนักงานสูง 36 ชั้น
                                        และอาคาร Production
                                        House สูง 12 ชั้น&nbsp;<br>
                                        &nbsp;</p>

                                    <table id="tif1" *ngIf="istif1" border="1" cellpadding="7" cellspacing="1"
                                        style="width:527px;">
                                        <tbody>
                                            <tr>
                                                <td style="text-align: center;">
                                                    <strong>ชื่อนิคม/เขต/สวนอุตสาหกรรม</strong></td>
                                                <td style="text-align: center;"><strong>ประเภท</strong></td>
                                                <td style="text-align: center;"><strong>ที่ตั้ง</strong></td>
                                                <td width="15%" style="text-align: center;"><strong>จำนวนโรงงาน</strong>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>1.ไฮเทค</td>
                                                <td>กรรมสิทธิ์ที่ดินและอาคารโรงงาน</td>
                                                <td>ตำบลบ้านเลน และตำบลบ้านโพ&nbsp;<br>
                                                    อำเภอบางปะอิน&nbsp;<br>
                                                    จังหวัดพระนครศรีอยุธยา</td>
                                                <td style="text-align: center;">12</td>
                                            </tr>
                                            <tr>
                                                <td>2. บางกะดี</td>
                                                <td>กรรมสิทธิ์ที่ดินและอาคารโรงงาน</td>
                                                <td>ตำบลบางกะดี &nbsp;อำเภอเมืองปทุมธานี จังหวัดปทุมธานี</td>
                                                <td style="text-align: center;">3</td>
                                            </tr>
                                            <tr>
                                                <td>3. บางปะอิน</td>
                                                <td>กรรมสิทธิ์ที่ดินและอาคารโรงงาน</td>
                                                <td>ตำบลคลองจิก อำเภอบางปะอิน&nbsp;<br>
                                                    จังหวัดพระนครศรีอยุธยา</td>
                                                <td style="text-align: center;">1</td>
                                            </tr>
                                            <tr>
                                                <td>4. นวนคร</td>
                                                <td>กรรมสิทธิ์ที่ดินและอาคารโรงงาน</td>
                                                <td>ตำบลคลองหนึ่ง &nbsp;อำเภอคลองหลวง &nbsp;จังหวัดปทุมธานี</td>
                                                <td style="text-align: center;">1</td>
                                            </tr>
                                            <tr>
                                                <td>5. อมตะนคร</td>
                                                <td>กรรมสิทธิ์ที่ดินและอาคารโรงงาน</td>
                                                <td>ตำบลหนองไม้แดง อำเภอเมืองชลบุรี&nbsp;<br>
                                                    จังหวัดชลบุรี</td>
                                                <td style="text-align: center;">7</td>
                                            </tr>
                                            <tr>
                                                <td>6. ทีเอฟดี</td>
                                                <td>กรรมสิทธิ์ที่ดินและอาคารโรงงาน</td>
                                                <td>ตำบลท่าสะอ้าน &nbsp;อำเภอบางปะกง &nbsp;จังหวัดฉะเชิงเทรา</td>
                                                <td style="text-align: center;">2</td>
                                            </tr>
                                            <tr>
                                                <td>รวม</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td style="text-align: center;">26</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <p *ngIf="istlhpf"><strong>ชื่อโครงการ : &nbsp;</strong>&nbsp; &nbsp;&nbsp;&nbsp;
                                        &nbsp;โครงการโรงแรมพีพี ฮอลิเดย์
                                        อินน์ รีสอร์ท ตำบลอ่าวนาง อำเภอเมืองกระบี่ จังหวัดกระบี่ &nbsp;<br>
                                        <br>
                                        <strong>ประเภท : </strong>&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;<br>
                                        <br>
                                        (1)&nbsp;&nbsp; &nbsp;กรรมสิทธิ์ในที่ดินโฉนดเลขที่ 58548 &nbsp;56838 และ 56839
                                        ตำบลอ่าวนาง
                                        อำเภอเมืองกระบี่ จังหวัดกระบี่ &nbsp;มีเนื้อที่รวมประมาณ 31 ไร่ 2 งาน 22
                                        ตารางวา<br>
                                        (2)&nbsp;&nbsp;
                                        &nbsp;กรรมสิทธิ์ในอาคารและสิ่งปลูกสร้างทั้งหมดซึ่งได้ปลูกสร้างและตั้งอยู่บนที่ดินตามข้อ
                                        (1) และ
                                        กรรมสิทธิ์ในส่วนควบของอาคารโครงการโรงแรม ระบบสาธารณูปโภค งานระบบ
                                        และทรัพย์สินอื่นที่เกี่ยวข้อง
                                        เกี่ยวเนื่องและจำเป็นต่อการใช้ประโยชน์ในระบบสาธารณูปโภค
                                        งานระบบของโครงการโรงแรม&nbsp;<br>
                                        (3)&nbsp;&nbsp; &nbsp;กรรมสิทธิ์ในเฟอร์นิเจอร์
                                        เครื่องมือและอุปกรณ์ที่เกี่ยวเนื่องและจำเป็นต่อการใช้ประโยชน์ในโครงการโรงแรม</p> -->

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xl-6">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6">
                                        <div class="info">
                                            <h3 *ngIf="isTrust" class="h6 topic-title">
                                                {{language.funddetailthm1b5detail5}}</h3>
                                            <h3 *ngIf="!isTrust" class="h6 topic-title">
                                                {{language.funddetailthm1b5detail6}}</h3>
                                            <p>{{fundCode}}</p>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-6">
                                        <div class="info">
                                            <h3 class="h6 topic-title">{{language.funddetailthm1b5detail7}}</h3>
                                            <p>{{regName}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6">
                                        <div class="info">
                                            <h3 *ngIf="isTrust" class="h6 topic-title">
                                                {{language.funddetailthm1b5detail8}}</h3>
                                            <h3 *ngIf="!isTrust" class="h6 topic-title">
                                                {{language.funddetailthm1b5detail9}}</h3>
                                            <p>{{trusteeName}}</p>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-6">
                                        <div class="info">
                                            <h3 *ngIf="isTrust" class="h6 topic-title">
                                                {{language.funddetailthm1b5detail13}}</h3>
                                            <h3 *ngIf="!isTrust" class="h6 topic-title">
                                                {{language.funddetailthm1b5detail11}}</h3>
                                            <p>{{incepDate}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6">
                                <div class="info">
                                    <h3 class="h6 topic-title">{{language.funddetailthm1b5detail12}}
                                    </h3>
                                    <p>{{accountPeriod}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="fundCode == 'ONE-COMPLEXRETURN'">
                            <div class="col-xl-6">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6">
                                        <div class="info">
                                            <app-button class="download-form" text="ข้อมูล Index Level"
                                                (click)="goIndexLevel()">
                                            </app-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="curve -white -top -have-doc" style="margin-top: 0;">
                    <section class="section-group" style="padding-top: 0;">
                        <div class="container">
                            <header class="heading-title">
                                <h2 class="topic-title">
                                    <span rel="border-circle">
                                        <i class="icon icon-price"></i>
                                    </span>
                                    <span class="text">{{language.funddetailthm1b6detail1}}</span>
                                </h2>
                            </header>
                            <div class="row" *ngIf="flag == 'th'">
                                <ul class="list-download list-unstyled" style="display: contents">
                                    <li class="col-md-6 col-xl-4" *ngFor="let item of doc_list">
                                        <a href="{{item.file_Path}}" *ngIf="item.file_Path.trim()" target="_blank">
                                            <span rel="border-circle">
                                                <i class="icon icon-arrow-down"></i>
                                            </span>
                                            <span>{{item.fileName}}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="row" *ngIf="flag == 'en'">
                                <ul class="list-download list-unstyled" style="display: contents">
                                    <li class="col-md-6 col-xl-4" *ngFor="let item of doc_listEN">
                                        <a href="{{item.file_Path_en}}" *ngIf="item.file_Path_en.trim()"
                                            target="_blank">
                                            <span rel="border-circle">
                                                <i class="icon icon-arrow-down"></i>
                                            </span>
                                            <span>{{item.fileName_en}}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </section>
                    <section class="section-group -graph non-border" *ngIf="!isTrust && !isProp">
                        <div class="container">
                            <section class="group-graph">
                                <header class="heading-title">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h2 class="topic-title">
                                                <span rel="border-circle">
                                                    <i class="icon icon-port"></i>
                                                </span>
                                                <span class="text">{{language.funddetailthm1b7detail1}} {{language.funddetailthm1b7detail1_asofdate}} {{top5HoldingAsofDate}}</span>
                                            </h2>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-7">
                                            <div class="group text-center">
                                                <h4 class="subtitle">{{language.funddetailthm1b7detail2}}</h4>
                                                <div style="width: 100%;">

                                                    <div id="container" class="pie-chart" [chart]="donut_x"></div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <section class="group-company">
                                                <h4 class="sub-title text-center">{{language.funddetailthm1b7detail3}}
                                                </h4>
                                                <table class="table table--noborder -company">
                                                    <tbody>
                                                        <tr *ngFor="let item of top5Holding">
                                                            <th *ngIf="flag == 'th'">{{item.Key}}</th>
                                                            <th *ngIf="flag == 'en'">{{item.KeyEn}}</th>
                                                            <td>{{fixFloatDigit(item.Value)}}%</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </section>
                                        </div>
                                    </div>
                                </header>
                            </section>
                        </div>
                    </section>
                </section>
            </div>

            <div *ngSwitchCase="'ผลการดำเนินงาน'" class="tab-pane fade show active" id="two" role="tabpanel"
                aria-labelledby="two-tab">
                <div class="container">

                    <section class="section-group section-graph non-border" style="padding-bottom: 0 !important"
                        *ngIf="!isTrust && !isProp">
                        <header>
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-graph-stock"></i>
                                </span>
                                <span class="text">{{language.funddetailthm2b1detail1}}</span>
                            </h2>
                        </header>
                        <div class="row">
                            <div class="col-lg-12">
                                <div style="width: 100%;">

                                    <div id="container" [chart]="chart_line"></div>
                                </div>
                            </div>
                        </div>
                        <ul class="list-inline list-year text-center d-none d-sm-none d-md-block d-lg-block d-xl-block">
                            <li>
                                <a class="indexSelector" (click)="onSearchGraph(1)"
                                    [ngClass]="(index_v == 1)?'active':''">YTD</a>
                            </li>
                            <li>
                                <a class="indexSelector" (click)="onSearchGraph(2)"
                                    [ngClass]="(index_v == 2)?'active':''">1M</a>
                            </li>
                            <li>
                                <a class="indexSelector" (click)="onSearchGraph(3)"
                                    [ngClass]="(index_v == 3)?'active':''">3M</a>
                            </li>
                            <li>
                                <a class="indexSelector" (click)="onSearchGraph(4)"
                                    [ngClass]="(index_v == 4)?'active':''">6M</a>
                            </li>
                            <li>
                                <a class="indexSelector" (click)="onSearchGraph(5)"
                                    [ngClass]="(index_v == 5)?'active':''">1Y</a>
                            </li>
                            <li>
                                <a class="indexSelector" (click)="onSearchGraph(6)"
                                    [ngClass]="(index_v == 6)?'active':''">3Y</a>
                            </li>
                            <li>
                                <a class="indexSelector" (click)="onSearchGraph(7)"
                                    [ngClass]="(index_v == 7)?'active':''">5Y</a>
                            </li>
                            <li>
                                <a class="indexSelector" (click)="onSearchGraph(8)"
                                    [ngClass]="(index_v == 8)?'active':''">10Y</a>
                            </li>
                            <li>
                                <a class="indexSelector" (click)="onSearchGraph(9)"
                                    [ngClass]="(index_v == 9)?'active':''">{{language.funddetailthm2b1detail1}}</a>
                            </li>
                        </ul>
                    </section>

                    <section class="section-group section-table" *ngIf="!isTrust && !isProp">
                        <header style="margin-bottom: 20px">
                            <div class="row">
                                <div class="col-lg-12 col-xl-12">
                                    <h2 class="topic-title">
                                        <span rel="border-circle">
                                            <i class="icon icon-data"></i>
                                        </span>
                                        <span class="text">{{language.funddetailthm2b2detail1}}</span>
                                    </h2>
                                </div>
                            </div>
                        </header>
                        <div id="nav-history-render">
                            <div class="wrapper-table-scroll table-responsive">
                                <table
                                    class="table table--fund table-striped table-hover fixed-columns responsive table-nomargin"
                                    width="100%">
                                    <thead>
                                        <tr>
                                            <th>{{language.funddetailthm2b2detail2}}</th>
                                            <th>{{language.funddetailthm2b2detail3}}</th>
                                            <th>{{language.funddetailthm2b2detail4}}</th>
                                            <th>{{language.funddetailthm2b2detail5}}</th>
                                            <th style="text-align: right; padding-right:15px;">
                                                {{language.funddetailthm2b2detail6}}
                                            </th>
                                            <th *ngIf="typeFund == 16 || typeFund == 15"
                                                style="text-align: right; padding-right:15px;">
                                                {{language.funddetailthm2b2detail7}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of filterNavHistory">
                                            <td class="text-center">{{item.FundPriceDate | date:'dd/MM/yyyy' }}</td>
                                            <td class="text-center">{{item.NavPublish | number: '1.4-4'}}</td>
                                            <td class="text-center" *ngIf="item.NavSub != 0 ; else isZero">{{item.NavSub | number: '1.4-4'}}</td>
                                            <td class="text-center" *ngIf="item.NavRed != 0 ; else isZero">{{item.NavRed | number: '1.4-4'}}</td>
                                            <ng-template #isZero>
                                                <td class="text-center">-</td>
                                            </ng-template>
                                            <td style="text-align: right; padding-right:15px;">
                                                {{item.NetAsset | number: '1.2-2'}}</td>
                                            <td *ngIf="typeFund == 16 || typeFund == 15"
                                                style="text-align: right; padding-right:15px;">
                                                {{item.TotalAsset | number: '1.2-2'}} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <footer class="text-center" style="margin-top: 40px;">
                            <app-paginator [currentPage]="currentPage" [totalPage]="totalPageCount"
                                (currentPageNumber)="setCurrentPage($event)"></app-paginator>
                        </footer>
                    </section>

                    <section class="section-group section-table" *ngIf="isTrust">
                        <header style="margin-bottom: 20px">
                            <div class="row">
                                <div class="col-lg-12 col-xl-12">
                                    <h2 class="topic-title">
                                        <span rel="border-circle">
                                            <i class="icon icon-data"></i>
                                        </span>
                                        <span class="text">{{language.funddetailthm2b3detail8}}</span>
                                    </h2>
                                </div>
                            </div>
                        </header>
                        <div id="nav-history-render">
                            <div class="wrapper-table-scroll table-responsive">
                                <table
                                    class="table table--fund table-striped table-hover fixed-columns responsive table-nomargin"
                                    width="100%">
                                    <thead>
                                        <tr>
                                            <th width="10%">{{language.funddetailthm2b2detail9}}</th>
                                            <th width="30%">{{language.funddetailthm2b2detail10}}</th>
                                            <!-- <th>ราคาขาย (THB/หน่วย)</th>
                      <th>ราคาซื้อคืน (THB/หน่วย)</th> -->
                                            <th width="35%" style="text-align: right; padding-right:15px;">
                                                {{language.funddetailthm2b2detail11}}</th>
                                            <th width="35%" *ngIf="typeFund == 16 || typeFund == 15"
                                                style="text-align: right; padding-right:15px;">
                                                {{language.funddetailthm2b2detail12}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of filterNavHistory">
                                            <td class="text-center">{{item.FundPriceDate | date:'dd/MM/yyyy' }}</td>
                                            <td class="text-center">{{item.NavPublish | number: '1.4-4'}}</td>
                                            <!-- <td class="text-center">{{item.NavSub | number: '1.4-4'}}</td>
                      <td class="text-center">{{item.NavRed | number: '1.4-4'}}</td> -->
                                            <td style="text-align: right; padding-right:15px;">
                                                {{item.NetAsset | number: '1.2-2'}}</td>
                                            <td *ngIf="typeFund == 16 || typeFund == 15"
                                                style="text-align: right; padding-right:15px;">
                                                {{item.TotalAsset | number: '1.2-2'}} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <footer class="text-center" style="margin-top: 40px;">
                            <app-paginator [currentPage]="currentPage" [totalPage]="totalPageCount"
                                (currentPageNumber)="setCurrentPage($event)"></app-paginator>
                        </footer>
                    </section>

                    <section class="section-group section-table" *ngIf="isProp">
                        <header style="margin-bottom: 20px">
                            <div class="row">
                                <div class="col-lg-12 col-xl-12">
                                    <h2 class="topic-title">
                                        <span rel="border-circle">
                                            <i class="icon icon-data"></i>
                                        </span>
                                        <span class="text">{{language.funddetailthm2b3detail13}}</span>
                                    </h2>
                                </div>
                            </div>
                        </header>
                        <div id="nav-history-render">
                            <div class="wrapper-table-scroll table-responsive">
                                <table
                                    class="table table--fund table-striped table-hover fixed-columns responsive table-nomargin"
                                    width="100%">
                                    <thead>
                                        <tr>
                                            <th width="10%">{{language.funddetailthm2b2detail20}}</th>
                                            <th width="30%">{{language.funddetailthm2b2detail22}}</th>
                                            <!-- <th>ราคาขาย (THB/หน่วย)</th>
                      <th>ราคาซื้อคืน (THB/หน่วย)</th> -->
                                            <th width="35%" style="text-align: right; padding-right:15px;">
                                                {{language.funddetailthm2b2detail23}}</th>
                                            <th width="35%" *ngIf="typeFund == 16 || typeFund == 15"
                                                style="text-align: right; padding-right:15px;">
                                                {{language.funddetailthm2b2detail24}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of filterNavHistory">
                                            <td class="text-center">{{item.FundPriceDate | date:'dd/MM/yyyy' }}</td>
                                            <td class="text-center">{{item.NavPublish | number: '1.4-4'}}</td>
                                            <!-- <td class="text-center">{{item.NavSub | number: '1.4-4'}}</td>
                      <td class="text-center">{{item.NavRed | number: '1.4-4'}}</td> -->
                                            <td style="text-align: right; padding-right:15px;">
                                                {{item.NetAsset | number: '1.2-2'}}</td>
                                            <td *ngIf="typeFund == 16 || typeFund == 15"
                                                style="text-align: right; padding-right:15px;">
                                                {{item.TotalAsset | number: '1.2-2'}} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <footer class="text-center" style="margin-top: 40px;">
                            <app-paginator [currentPage]="currentPage" [totalPage]="totalPageCount"
                                (currentPageNumber)="setCurrentPage($event)"></app-paginator>
                        </footer>
                    </section>

                    <section *ngIf="isDeviden || isTrust" class="section-group section-table">
                        <header style="margin-bottom: 20px">
                            <div class="row">
                                <div class="col-lg-7 col-xl-6">
                                    <h2 class="topic-title">
                                        <span rel="border-circle">
                                            <i class="icon icon-devided"></i>
                                        </span>
                                        <span *ngIf="isTrust" class="text">{{language.funddetailthm2b3detail29}}</span>
                                        <span *ngIf="!isTrust" class="text">{{language.funddetailthm2b3detail18}}</span>
                                    </h2>
                                </div>
                                <div class="col-lg-5 col-xl-6 -md" style="text-align: right;">
                                    <div class="group-botton">
                                        <a class="btn btn-primary -bg-white -download"
                                            (click)="export()">{{language.funddetailthm2b3detail19}} </a>
                                    </div>
                                </div>
                            </div>
                        </header>
                        <div id="nav-history-render">
                            <div class="wrapper-table-scroll table-responsive">

                                <table
                                    class="table table--fund table-striped table-hover fixed-columns responsive table-nomargin"
                                    width="100%" id="devidend" style="display: none;">
                                    <thead>
                                        <tr>
                                            <th>{{language.funddetailthm2b2detail20}}</th>
                                            <th>{{language.funddetailthm2b2detail21}}</th>
                                            <th>{{language.funddetailthm2b2detail22}}</th>
                                            <th>{{language.funddetailthm2b2detail23}}</th>
                                            <th>{{language.funddetailthm2b2detail24}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of bind_data2">
                                            <td class="text-center">{{item.No}}</td>
                                            <td class="text-center">{{fundCode}}</td>
                                            <td class="text-center">{{item.DivPerUnit | number: '1.4-4'}}</td>
                                            <td class="text-center">{{item.ExDivDate | date:'dd/MM/yyyy'}}</td>
                                            <td class="text-center" style="text-align: right; padding-right:15px;">
                                                {{item.PaymentDate | date:'dd/MM/yyyy'}}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table
                                    class="table table--fund table-striped table-hover fixed-columns responsive table-nomargin"
                                    width="100%" id="dividend2">
                                    <thead>
                                        <tr>
                                            <th>{{language.funddetailthm2b2detail25}}</th>
                                            <th>{{language.funddetailthm2b2detail26}}</th>
                                            <th>{{language.funddetailthm2b2detail27}}</th>
                                            <th>{{language.funddetailthm2b2detail28}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of filterDevidenHistory">
                                            <td class="text-center">{{item.No}}</td>
                                            <td class="text-center">{{item.DivPerUnit | number: '1.4-4'}}</td>
                                            <td class="text-center">{{item.ExDivDate | date:'dd/MM/yyyy'}}</td>
                                            <td class="text-center" style="text-align: right; padding-right:15px;">
                                                {{item.PaymentDate | date:'dd/MM/yyyy'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!--------------------------------------------------------------------------------------------------------------------------------->
                                <!------------------------------------- element Table for Download Deviden All ---------------------------------------------------->
                                <table id="dividendForDownload" style="display: none">
                                    <thead>
                                        <tr>
                                            <th>{{language.funddetailthm2b2detail25}}</th>
                                            <th>{{language.funddetailthm2b2detail26}}</th>
                                            <th>{{language.funddetailthm2b2detail27}}</th>
                                            <th>{{language.funddetailthm2b2detail28}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of FundDevidenHistoryTH">
                                            <td class="text-center">{{item.No}}</td>
                                            <td class="text-center">{{item.DivPerUnit}}</td>
                                            <td class="text-center">{{item.ExDivDate}}</td>
                                            <td class="text-center" style="text-align: right; padding-right:15px;">
                                                {{item.PaymentDate}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!------------------------------------- element Table for Download Deviden All ---------------------------------------------------->
                                <!--------------------------------------------------------------------------------------------------------------------------------->
                            </div>
                        </div>
                        <footer class="text-center" style="margin-top: 40px;">
                            <app-paginator [currentPage]="devidendCurrentPage" [totalPage]="totalDevidendPageCount"
                                (currentPageNumber)="setDevidendCurrentPage($event)" [isEn]="false"></app-paginator>
                        </footer>
                    </section>

                    <section class="section-group section-cal">
                        <div class="row">
                            <!-- เครื่องคำนวณการลงทุน -->
                            <div class="col-md-6">
                                <section class="widget -cal -first">
                                    <form action="" class="form -day">
                                        <header>
                                            <h3 class="topic-title">
                                                <span rel="border-circle" style="margin-left: 0;">
                                                    <i class="icon icon-cal"></i>
                                                </span>
                                                <span class="text">{{language.funddetailthm2b3detail1}}</span>
                                            </h3>
                                            <p class="intro" style="margin-bottom: 0;">
                                                {{language.funddetailthm2b3detail2}}
                                            </p>
                                        </header>

                                        <div class="form-group">
                                            <app-select [selectList]="selectListDropdown"
                                                defaultTitle="{{language.fundcompare4}}" [isLight]="false"
                                                [isRequire]="invalidPerfInvest" [enableSearch]="true"
                                                (fundId)="getFundIdFromSelect($event)">
                                            </app-select>
                                        </div>

                                        <div class="form-group">
                                            <app-datepicker [defaultPlaceholder]="language.defaulttitledate1"
                                                (pickDate)="getPickDate($event)" #datepick1
                                                (blur)="setDate1(datepick1.value)"></app-datepicker>
                                        </div>

                                        <footer class="text-align -xs">
                                            <app-button size="cal-full" text="{{language.defaulttitlebtn}}"
                                                (click)="clickCalculate('เครื่องคำนวณการลงทุน')">
                                            </app-button>
                                            <div id="btnPerformance-trigger" class="hidden" data-toggle="modal"
                                                data-target="#perforModal">
                                            </div>
                                        </footer>

                                    </form>
                                </section>
                            </div>

                            <!-- ผลการดำเนินงานกองทุน -->
                            <div class="col-md-6">
                                <section class="widget -cal -first -last">
                                    <form action="" class="form -day">
                                        <header>
                                            <h3 class="topic-title">
                                                <span rel="border-circle" style="margin-left: 0;">
                                                    <i class="icon icon-barchart-fund"></i>
                                                </span>
                                                <span class="text">{{language.funddetailthm2b4detail1}}</span>
                                            </h3>
                                            <p class="intro" style="margin-bottom: 0;">
                                                {{language.funddetailthm2b4detail2}}
                                            </p>
                                        </header>

                                        <div class="form-group">
                                            <app-select [selectList]="selectListDropdown"
                                                defaultTitle="{{language.fundcompare4}}" [isLight]="false"
                                                [isRequire]="invalidFundPerf" [enableSearch]="true"
                                                (fundId)="getFundIdFromSelect2($event)">
                                            </app-select>
                                        </div>

                                        <div class="form-group">
                                            <app-datepicker class="selectiongroup2"
                                                [defaultPlaceholder]="language.defaulttitledate2"
                                                (pickDate)="getPickDate2($event)" #datepick2
                                                (blur)="setDate2(datepick2.value)">
                                            </app-datepicker>
                                        </div>

                                        <footer class="text-align -xs">
                                            <app-button size="cal-full" text="{{language.defaulttitlebtn}}"
                                                (click)="clickCalculate2('ผลการดำเนินงานกองทุน')">
                                            </app-button>
                                            <div id="btnPerformance-trigger" class="hidden" data-toggle="modal"
                                                data-target="#perforModal">
                                            </div>
                                        </footer>

                                    </form>
                                </section>
                            </div>
                        </div>
                    </section>

                </div>
            </div>

            <div *ngSwitchCase="'การซื้อขายหน่วยลงทุน'" class="tab-pane fade show active" id="three" role="tabpanel"
                aria-labelledby="three-tab">
                <div class="container">

                    <section *ngIf="!isStoxxUSD && !isETF && !isTrust && !isProp"
                        class="section-group section-fee -fund" style="padding-top: 0;">
                        <header class="heading-title">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-e-chart"></i>
                                </span>
                                <span class="text">{{language.funddetailthm3b1detail1}}</span>
                            </h2>
                        </header>
                        <div class="row">
                            <div class="col-xl-6 group-list">
                                <section>
                                    <h3 class="h4 title" style="height: 27px;">
                                        <i class="icon icon-buy"></i>
                                        <span class="text">{{language.funddetailthm3b1detail2}}</span>
                                    </h3>
                                    <ul class="list list-unstyled list-bullet-fee">
                                        <li>
                                            <span>{{language.funddetailthm3b1detail3}}</span>
                                            <span
                                                *ngIf="MinFirstTradeAmt != 'ไม่กำหนด' && MinFirstTradeAmt != 'Undefined'"
                                                class="result">
                                                <em>{{MinFirstTradeAmt | number}}</em>
                                                {{language.funddetailthm3b1detail4}}
                                            </span>
                                            <span
                                                *ngIf="MinFirstTradeAmt == 'ไม่กำหนด' || MinFirstTradeAmt == 'Undefined'"
                                                class="result-1">
                                                <em>{{MinFirstTradeAmt}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b1detail5}}</span>
                                            <span *ngIf="MinTradeAmt != 'ไม่กำหนด' && MinTradeAmt != 'Undefined'"
                                                class="result">
                                                <em>{{MinTradeAmt | number}}</em> {{language.funddetailthm3b1detail4}}
                                            </span>
                                            <span *ngIf="MinTradeAmt == 'ไม่กำหนด' || MinTradeAmt == 'Undefined'"
                                                class="result-1">
                                                <em>{{MinTradeAmt}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b1detail6}}</span>
                                            <span
                                                *ngIf="MinFundGiftCard != 'ไม่กำหนด' && MinFundGiftCard != 'Undefined'"
                                                class="result">
                                                <em>{{MinFundGiftCard | number}}</em>
                                                {{language.funddetailthm3b1detail4}}
                                            </span>
                                            <span
                                                *ngIf="MinFundGiftCard == 'ไม่กำหนด' || MinFundGiftCard == 'Undefined'"
                                                class="result-1">
                                                <em>{{MinFundGiftCard}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b1detail7}}</span>
                                            <span *ngIf="BuyTime != 'ไม่กำหนด' && BuyTime != 'Undefined'"
                                                class="result">
                                                <em>{{BuyTime}}</em> {{BuyCondition}}
                                            </span>
                                            <span *ngIf="BuyTime == 'ไม่กำหนด' || BuyTime == 'Undefined'"
                                                class="result-1">
                                                <em>{{BuyTime}}</em>
                                            </span>
                                        </li>
                                    </ul>
                                    <ul class="list list-link-button">
                                        <li>
                                            <a class="btn btn-primary -brand -short"
                                                href="https://onelive.one-asset.com/Home" target="_blank"
                                                *ngIf="flag == 'th'">{{language.funddetailthm3b1detail8}}</a>
                                            <a class="btn btn-primary -brand -short"
                                                href="https://onelive.one-asset.com/Home" target="_blank"
                                                *ngIf="flag == 'en'"
                                                style="font-size: 18px;">{{language.funddetailthm3b1detail8}}</a>
                                        </li>
                                        <li>
                                            <a class="btn btn-primary -brand -short"
                                                href="https://onelive.one-asset.com/Home"
                                                target="_blank">{{language.funddetailthm3b1detail9}}</a>
                                        </li>
                                    </ul>
                                </section>
                            </div>
                            <div class="col-xl-6 group-list">
                                <section>
                                    <h3 class="h4 title" style="height: 27px;">
                                        <i class="icon icon-sell"></i>
                                        <span class="text">{{language.funddetailthm3b2detail1}}</span>
                                    </h3>
                                    <ul class="list list-unstyled list-bullet-fee">
                                        <li>
                                            <span>{{language.funddetailthm3b2detail2}}</span>
                                            <span *ngIf="MinBalanceUnit != 'ไม่กำหนด' && MinBalanceUnit != 'Undefined'"
                                                class="result">
                                                <em>{{MinBalanceUnit | number}}</em>
                                                {{language.funddetailthm3b2detail3}}
                                            </span>
                                            <span *ngIf="MinBalanceUnit == 'ไม่กำหนด' || MinBalanceUnit == 'Undefined'"
                                                class="result-1">
                                                <em>{{MinBalanceUnit}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b2detail4}}</span>
                                            <span
                                                *ngIf="MinSellTradeAmt != 'ไม่กำหนด' && MinSellTradeAmt != 'Undefined'"
                                                class="result">
                                                <em>{{MinSellTradeAmt | number}}</em> {{language.funddetailthm3b1detail4}}
                                            </span>
                                            <span
                                                *ngIf="MinSellTradeAmt == 'ไม่กำหนด' || MinSellTradeAmt == 'Undefined'"
                                                class="result-1">
                                                <em>{{MinSellTradeAmt}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b2detail5}}</span>
                                            <span *ngIf="MinBalanceBaht != 'ไม่กำหนด' && MinBalanceBaht != 'Undefined'"
                                                class="result">
                                                <em>{{MinBalanceBaht | number}}</em> {{language.funddetailthm3b1detail4}}
                                            </span>
                                            <span *ngIf="MinBalanceBaht == 'ไม่กำหนด' || MinBalanceBaht == 'Undefined'"
                                                class="result-1">
                                                <em>{{MinBalanceBaht}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b2detail6}}</span>
                                            <span *ngIf="SellTime != 'ไม่กำหนด' && SellTime != 'Undefined'"
                                                class="result">
                                                <em>{{SellTime}}</em> {{SellCondition}}
                                            </span>
                                            <span *ngIf="SellTime == 'ไม่กำหนด' || SellTime == 'Undefined'"
                                                class="result-1">
                                                <em>{{SellTime}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b2detail7}}</span>
                                            <span class="result">
                                                <em>{{language.funddetailthm3b2detail8}} {{SettlementDate}}
                                                    {{language.funddetailthm3b2detail9}}</em>
                                                <br>
                                                {{language.funddetailthm3b2detail10}} (T+{{SettlementDate}})
                                            </span>
                                        </li>
                                    </ul>
                                </section>
                            </div>

                        </div>
                    </section>

                    <section *ngIf="!isStoxxUSD && isETF && !isTrust && !isProp" class="section-group section-howto"
                        style="padding-top: 0;">
                        <header class="heading-title">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-e-chart"></i>
                                </span>
                                <span class="text">{{language.funddetailthm3b1detail10}}</span>
                            </h2>
                        </header>

                        <article>
                            <ul class="list-unstyled list-bullet-number">
                                <li>
                                    <h5 class="f-semibold">
                                        <span class="number">1</span>
                                        <span class="text">{{language.funddetailthm3b1detail11}}</span>
                                    </h5>
                                    <div class="intro p-1">
                                        <p>{{language.funddetailthm3b1detail12}}</p>
                                    </div>
                                </li>

                                <li>
                                    <h5 class="f-semibold">
                                        <span class="number">2</span><span
                                            class="text">{{language.funddetailthm3b1detail13}}</span>
                                    </h5>
                                    <div class="intro p-1">
                                        <p>{{language.funddetailthm3b1detail14}}
                                        </p>
                                        <p style="margin-top: 15px;">{{language.funddetailthm3b1detail15}}
                                            <br> {{language.funddetailthm3b1detail16}}
                                        </p>

                                    </div>
                                </li>
                            </ul>

                            <footer style="margin-top: 30px;">
                                <ul class="list list-unstyled list-detail">
                                    <li style="padding-top: 10px; padding-bottom: 10px;">
                                        <span
                                            style="width: 25%; font-weight: 400; display: inline-block; font-size: 24px;"
                                            class="title h5">{{language.funddetailthm3b1detail17}}</span>
                                        <span style="display: inline-block; font-size: 20px;"
                                            class="text p-1">{{language.funddetailthm3b1detail18}}</span>
                                    </li>
                                    <li *ngIf="fundCode==='1DIV'" style="padding-top: 10px; padding-bottom: 10px; ">
                                        <span
                                            style="width: 25%; font-weight: 400; display: inline-block; font-size: 24px;"
                                            class="title h5">Settlement Date</span>
                                        <span style="display: inline-block; font-size: 20px;" class="text p-1">T +
                                            3</span>

                                    </li>
                                    <li *ngIf="fundCode==='TDEX'" style="padding-top: 10px; padding-bottom: 10px; ">
                                        <span
                                            style="width: 25%; font-weight: 400; display: inline-block; font-size: 24px;"
                                            class="title h5">Settlement Date</span>
                                        <span style="display: inline-block; font-size: 20px;" class="text p-1">T +
                                            3</span>

                                    </li>
                                    <li *ngIf="fundCode==='TH100'" style="padding-top: 10px; padding-bottom: 10px; ">
                                        <span
                                            style="width: 25%; font-weight: 400; display: inline-block; font-size: 24px;"
                                            class="title h5">Settlement Date</span>
                                        <span style="display: inline-block; font-size: 20px;"
                                            class="text p-1">{{language.funddetailthm3b1detail19}}</span>
                                    </li>
                                </ul>
                            </footer>

                        </article>
                    </section>

                    <section *ngIf="!isStoxxUSD && !isETF && isTrust" class="section-group section-howto"
                        style="padding-top: 0;">
                        <header class="heading-title">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-e-chart"></i>
                                </span>
                                <span class="text">{{language.funddetailthm3b1detail20}}</span>
                            </h2>
                        </header>

                        <article>
                            <ul class="list-unstyled list-bullet-number">
                                <li>
                                    <div class="intro p-1" style="font-size: 16px;">
                                        <p>{{language.funddetailthm3b1detail24}}
                                        </p>
                                        <p style="margin-top: 15px;">{{language.funddetailthm3b1detail22}}
                                            <br> {{language.funddetailthm3b1detail23}}
                                        </p>

                                    </div>
                                </li>
                            </ul>

                        </article>
                    </section>

                    <section *ngIf="!isStoxxUSD && !isETF && !isTrust && isProp" class="section-group section-howto"
                        style="padding-top: 0;">
                        <header class="heading-title">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-e-chart"></i>
                                </span>
                                <span class="text">{{language.funddetailthm3b1detail20}}</span>
                            </h2>
                        </header>

                        <article>
                            <ul class="list-unstyled list-bullet-number">
                                <li>
                                    <div class="intro p-1" style="font-size: 16px;">
                                        <p>{{language.funddetailthm3b1detail21}}
                                        </p>
                                        <p style="margin-top: 15px;">{{language.funddetailthm3b1detail22}}
                                            <br> {{language.funddetailthm3b1detail23}}
                                        </p>

                                    </div>
                                </li>
                            </ul>

                        </article>
                    </section>

                    <section class="section-group section-fee -dealing" *ngIf="!isTrust && !isProp">
                        <header class="heading-title">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-cart-coin"></i>
                                </span>
                                <span class="text">{{language.funddetailthm3b3detail1}}</span>
                            </h2>
                        </header>
                        <div class="row">
                            <div class="col-xl-6 group-list">
                                <section>

                                    <h3 *ngIf="!isStoxxUSD" class="h4 title" style="height: 55px;">
                                        <i class="icon icon-coin"></i>
                                        <span class="text">
                                            {{language.funddetailthm3b3detail2}}
                                            <small>
                                                <br class="d-block d-sm-none">
                                                {{language.funddetailthm3b3detail3}}</small>
                                        </span>
                                    </h3>

                                    <ul *ngIf="!isStoxxUSD" class="list list-unstyled list-bullet-fee">
                                        <li>
                                            <span>{{language.funddetailthm3b3detail4}}</span>
                                            <span *ngIf="FeeBuy != 'ไม่กำหนด' && FeeBuy != 'Undefined'" class="result">
                                                <em>{{FeeBuy}}</em>
                                            </span>
                                            <span *ngIf="FeeBuy == 'ไม่กำหนด' || FeeBuy == 'Undefined'"
                                                class="result-1">
                                                <em>{{FeeBuy}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail5}}</span>
                                            <span *ngIf="FeeSell != 'ไม่กำหนด' && FeeSell != 'Undefined'"
                                                class="result">
                                                <em>{{FeeSell}}</em>
                                            </span>
                                            <span *ngIf="FeeSell == 'ไม่กำหนด' || FeeSell == 'Undefined'"
                                                class="result-1">
                                                <em>{{FeeSell}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail6}}</span>
                                            <span *ngIf="FeeSwitchIn != 'ไม่กำหนด' && FeeSwitchIn != 'Undefined'"
                                                class="result">
                                                <em>{{FeeSwitchIn}}</em>
                                            </span>
                                            <span *ngIf="FeeSwitchIn == 'ไม่กำหนด' || FeeSwitchIn == 'Undefined'"
                                                class="result-1">
                                                <em>{{FeeSwitchIn}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail7}}</span>
                                            <span *ngIf="FeeSwithOut != 'ไม่กำหนด' && FeeSwithOut != 'Undefined'"
                                                class="result">
                                                <em>{{FeeSwithOut}}</em>
                                            </span>
                                            <span *ngIf="FeeSwithOut == 'ไม่กำหนด' || FeeSwithOut == 'Undefined'"
                                                class="result-1">
                                                <em>{{FeeSwithOut}}</em>
                                            </span>
                                        </li>
                                    </ul>
                                </section>
                            </div>

                            <div class="col-xl-6 group-list">
                                <section>
                                    <h3 *ngIf="!isStoxxUSD" class="h4 title">
                                        <i class="icon icon-coin"></i>
                                        <span class="text">
                                            {{language.funddetailthm3b3detail8}}
                                            <br>
                                            <small>{{language.funddetailthm3b3detail9}}</small>
                                        </span>
                                    </h3>
                                    <h3 *ngIf="isStoxxUSD" class="h4 title">
                                        <i class="icon icon-coin"></i>
                                        <span class="text">
                                            Fees and Charges payable by you if you invest in the Fund through the SGX-ST
                                        </span>
                                    </h3>
                                    <ul *ngIf="!isStoxxUSD" class="list list-unstyled list-bullet-fee">
                                        <li>
                                            <span>{{language.funddetailthm3b3detail10}}</span>
                                            <span class="result">
                                                <em>{{FeeRegister}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail11}}</span>
                                            <span class="result">
                                                <em>{{FeeManagement}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail12}}</span>
                                            <span class="result">
                                                <em>{{FeeTrustee}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail13}}</span>
                                            <span class="result">
                                                <em>{{FeeOther}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail14}}</span>
                                            <span class="result">
                                                <em>{{FeeTotal}}</em>
                                            </span>
                                        </li>

                                    </ul>
                                </section>
                            </div>
                        </div>
                    </section>

                    <section class="section-group section-fee -dealing" *ngIf="isTrust">
                        <header class="heading-title">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-cart-coin"></i>
                                </span>
                                <span class="text">{{language.funddetailthm3b3detail15}}</span>
                            </h2>
                        </header>
                        <div class="row">

                            <div class="col-xl-6 group-list">
                                <section>
                                    <h3 *ngIf="!isStoxxUSD" class="h4 title">
                                        <i class="icon icon-coin"></i>
                                        <span class="text">
                                            {{language.funddetailthm3b3detail16}}
                                            <br>
                                            <small>{{language.funddetailthm3b3detail17}}</small>
                                        </span>
                                    </h3>
                                    <ul class="list list-unstyled list-bullet-fee">
                                        <li>
                                            <span>{{language.funddetailthm3b3detail18}}</span>
                                            <span class="result">
                                                <em>{{FeeRegister}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail19}}</span>
                                            <span class="result">
                                                <em>{{FeeManagement}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail20}}</span>
                                            <span class="result">
                                                <em>{{FeeTrustee}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail21}}</span>
                                            <span class="result">
                                                <em>{{FeeOther}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail22}}</span>
                                            <span class="result">
                                                <em>{{FeeTotal}}</em>
                                            </span>
                                        </li>

                                    </ul>
                                </section>
                            </div>
                        </div>
                    </section>

                    <section class="section-group section-fee -dealing" *ngIf="isProp">
                        <header class="heading-title">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-cart-coin"></i>
                                </span>
                                <span class="text">{{language.funddetailthm3b3detail23}}</span>
                            </h2>
                        </header>
                        <div class="row">

                            <div class="col-xl-6 group-list">
                                <section>
                                    <h3 *ngIf="!isStoxxUSD" class="h4 title">
                                        <i class="icon icon-coin"></i>
                                        <span class="text">
                                            {{language.funddetailthm3b3detail24}}
                                            <br>
                                            <small>{{language.funddetailthm3b3detail25}}</small>
                                        </span>
                                    </h3>
                                    <ul class="list list-unstyled list-bullet-fee">
                                        <li>
                                            <span>{{language.funddetailthm3b3detail26}}</span>
                                            <span class="result">
                                                <em>{{FeeRegister}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail27}}</span>
                                            <span class="result">
                                                <em>{{FeeManagement}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail28}}</span>
                                            <span class="result">
                                                <em>{{FeeTrustee}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail29}}</span>
                                            <span class="result">
                                                <em>{{FeeOther}}</em>
                                            </span>
                                        </li>
                                        <li>
                                            <span>{{language.funddetailthm3b3detail30}}</span>
                                            <span class="result">
                                                <em>{{FeeTotal}}</em>
                                            </span>
                                        </li>

                                    </ul>
                                </section>
                            </div>
                        </div>
                    </section>

                    <section class="section-group section-calendar" *ngIf="calendar">
                        <header class="heading-title">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-calendar-white"></i>
                                </span>
                                <span class="text">{{language.funddetailthm3b4detail1}}</span>
                            </h2>
                        </header>
                        <ul class="row list-download list-unstyled">
                            <li class="col-md-6 col-xl-4" *ngFor="let item of doc_calendar">
                                <div *ngIf="flag == 'th'; else elsedoc_calendar">
                                    <a href="{{item.file_Path}}" target="_blank">
                                        <span rel="border-circle">
                                            <i class="icon icon-arrow-down"></i>
                                        </span>
                                        <span>{{item.fileName}}</span>
                                    </a>
                                </div>
                                <ng-template #elsedoc_calendar>
                                    <a href="{{item.file_Path_en}}" target="_blank">
                                        <span rel="border-circle">
                                            <i class="icon icon-arrow-down"></i>
                                        </span>
                                        <span>{{item.fileName_en}}</span>
                                    </a>
                                </ng-template>
                            </li>
                        </ul>
                    </section>

                    <section class="section-group section-have-intro">
                        <header>
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-cart-line"></i>
                                </span>
                                <span class="text">{{language.funddetailthm3b5detail1}}</span>
                            </h2>
                        </header>
                        <div class="intro">
                            <p *ngIf="!isTrust&& !isProp" class="font-24">{{language.funddetailthm3b5detail2}}
                            </p>
                            <p *ngIf="isTrust || isProp" class="font-24">
                                {{language.funddetailthm3b5detail3}}
                            </p>
                        </div>
                        <ul *ngIf="!openTop && !isTrust && !isProp" class="list-channel list-unstyled list-inline">
                            <li class="col-12 col-lg-3 col-xl-3">
                                <a href="https://onelive.one-asset.com/Home" target="_blank">
                                    <span rel="border-circle">
                                        <i class="icon icon-online"></i>
                                    </span>
                                    <span class="text h4">
                                        One Live
                                        <small>
                                            {{language.funddetailthm3b5detail4}}
                                            <br>
                                            {{language.funddetailthm3b5detail5}}
                                        </small>
                                    </span>
                                </a>
                            </li>

                            <li class="col-12 col-lg-3 col-xl-3">
                                <span rel="border-circle">
                                    <i class="icon icon-smartphone"></i>
                                </span>
                                <span class="text h4">
                                    Mobile App
                                    <span class="group-icon">
                                        <a href="https://play.google.com/store/apps/details?id=th.co.itg.oneasset"
                                            class="app-store" target="_blank" style="margin-right: 10px;">
                                            <img src="../../../assets/images/logo/icon-googleplay@2x.png"
                                                class="img-fluid" alt="googlePlay">
                                        </a>
                                        <a href="https://itunes.apple.com/us/app/oneam/id1267201693?ls=1&mt=8"
                                            class="app-store" target="_blank">
                                            <img src="../../../assets/images/logo/icon-appstore@2x.png"
                                                class="img-fluid" alt="appStore">
                                        </a>
                                    </span>
                                </span>
                            </li>


                            <li class="col-12 col-lg-3 col-xl-3 text-right -lg">
                                <span rel="border-circle">
                                    <i class="icon icon-phone-big"></i>
                                </span>
                                <span class="text h4">
                                    {{language.funddetailthm3b5detail6}}
                                    <br>
                                    <div *ngIf="flag == 'en'">
                                        {{language.funddetailthm3b5detail8}}
                                        <br>
                                    </div>
                                    Customer Service
                                    <small>
                                        {{language.funddetailthm3b5detail7}}
                                        <span class="number">0 2659 8888</span>
                                    </small>

                                </span>
                            </li>
                        </ul>
                    </section>

                    <section *ngIf="!isStoxxUSD && hasSupporter && !isTrust && !isProp"
                        class="section-group section-dealer non-border">
                        <header>
                            <h2 class="topic-title h4">
                                <span rel="border-circle" class="big-orange">
                                    <i class="icon icon-headphone"></i>
                                </span>
                                <span class="text">
                                    {{language.funddetailthm3b6detail1}}
                                    <br>
                                    {{language.funddetailthm3b6detail2}}
                                </span>
                            </h2>
                        </header>
                        <div class="section-sponsor">
                            <ul class="list-sponsor list-unstyled">
                                <div class="row">
                                    <li class="col-md-6" *ngFor="let item of supporter">
                                        <span class="info" style="height: 61px;">
                                            <span *ngIf="flag == 'th'" class="text">{{item.AgentNameTh}}</span>
                                            <span *ngIf="flag == 'en'" class="text">{{item.AgentNameEn}}</span>
                                            <span class="number">
                                                <a href="#">
                                                    <i class="icon icon-phone"></i>
                                                    {{item.TelNo}}
                                                </a>
                                            </span>
                                        </span>
                                    </li>
                                </div>
                            </ul>
                        </div>
                    </section>

                </div>

            </div>

            <div *ngSwitchCase="'ราคา/ตะกร้าหุ้น'" class="tab-pane fade show active" id="four" role="tabpanel"
                aria-labelledby="four-tab">
                <div *ngIf="isETF" class="container">
                    <section *ngIf="!isStoxxUSD" class="section-group section-etf-price">
                        <header class="heading-title">
                            <h2 class="topic-title">
                                <span rel="border-circle">
                                    <i class="icon icon-price"></i>
                                </span>
                                <span class="text">{{language.funddetailthm4detail1}}</span>
                            </h2>
                        </header>
                        <section class="list-stock">
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-4">
                                    <section class="widget -stock">
                                        <header data-mh="header-stock" style="height: 62px;">
                                            <h3 class="title h4">Intraday Indicative Value(IIV)</h3>
                                            <time id="iivDate">
                                                {{language.funddetailthm4detail2}}
                                                <span>{{Tab4ValuationDate}}</span>
                                            </time>
                                        </header>
                                        <div class="value">
                                            <span class="number" id="iivValue"></span>
                                            <span class="index">
                                                <i class="icon icon-arrow-index"></i>
                                                <span class="number">{{Tab4IIV}}</span>
                                            </span>
                                        </div>
                                    </section>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <section class="widget -stock">
                                        <header data-mh="header-stock" style="height: 62px;">
                                            <h3 class="title h4">NAV per Unit(NAV)</h3>
                                            <time id="iivDate">
                                                {{language.funddetailthm4detail2}} {{Tab4ValuationDate}}
                                            </time>
                                        </header>
                                        <div class="value">
                                            <span class="number">{{Tab4NAVPerUnit}}</span>
                                        </div>
                                    </section>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <section class="widget -stock">
                                        <header data-mh="header-stock" style="height: 62px;">
                                            <h3 class="title h4">Balancing Amount(BA)</h3>
                                            <time id="iivDate">
                                                {{language.funddetailthm4detail2}} {{Tab4ValuationDate}}
                                            </time>
                                        </header>
                                        <div class="value">
                                            <span class="number">{{Tab4BAAmount | number: '1.2'}}</span>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </section>
                    </section>

                    <section *ngIf="!isStoxxUSD" class="section-group section-table section-stock">
                        <header>
                            <div class="row">
                                <div class="col-lg-7 col-xl-6">
                                    <h2 class="topic-title">
                                        <span rel="border-circle">
                                            <i class="icon icon-data"></i>
                                        </span>
                                        <span class="text">
                                            {{language.funddetailthm4detail3}}
                                            <small>{{language.funddetailthm4detail4}}</small>
                                        </span>
                                    </h2>

                                    <app-datepicker [requireSelDate]='true' (pickDate)="getPdfDate($event)">
                                    </app-datepicker>


                                </div>

                                <div class="col-lg-5 col-xl-6 text-right -md">
                                    <div class="group-button">
                                        <a class="btn btn-primary -bg-white -download" id="download-pdf"
                                            (click)="exportFile('pdfBasket')">{{language.funddetailthm4detail5}}</a>
                                        <a class="btn btn-primary -bg-white -download" id="download-ba"
                                            (click)="exportFile('BA/NAV')">{{language.funddetailthm4detail6}}</a>
                                    </div>
                                </div>
                            </div>
                        </header>

                        <div class="share-table">
                            <div class="wrap-table">

                                <!-- BA Table -->
                                <table class="table table--fund -stock table-striped table-hover" style="display: none"
                                    width="100%" id="BABasket">
                                    <thead>
                                        <tr>
                                            <th>ETFSymbol</th>
                                            <th>UnitPerCU</th>
                                            <th>BAAmount</th>
                                            <th>TotalNAVAmount</th>
                                            <th>NAVPerUnit</th>
                                            <th>NAVSub</th>
                                            <th>NAVRed</th>
                                            <th>ValuationDate</th>
                                            <th>ETFMarketID</th>
                                            <th>ETFISINCode</th>
                                            <th>IIV</th>
                                            <th>NAVChange</th>
                                            <th>PercentChange</th>
                                            <th>TrackingError</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{Tab4ETFSymbol}}</td>
                                            <td>{{Tab4UnitPerCU | number}}</td>
                                            <td>{{Tab4BAAmount | number}}</td>
                                            <td>{{Tab4TotalNavAmount | number}}</td>
                                            <td>{{Tab4NAVPerUnit | number : '1.4-4'}}</td>
                                            <td>{{Tab4NavSub | number}}</td>
                                            <td>{{Tab4NavRed | number}}</td>
                                            <td>{{responsedate}}</td>
                                            <td>{{Tab4ETFMarketID}}</td>
                                            <td>{{Tab4ETFISINCode}}</td>
                                            <td>{{Tab4IIV | number : '1.4-4'}}</td>
                                            <td>{{NAVChange}}</td>
                                            <td>{{PercentChange}}</td>
                                            <td>{{TrackingError}}</td>
                                        </tr>

                                    </tbody>

                                </table>

                                <table class="table table--fund -stock table-striped table-hover" width="100%"
                                    id="pdfBasket">
                                    <thead>
                                        <tr>
                                            <th width="40%">{{language.funddetailthm4detail7}}</th>
                                            <th>{{language.funddetailthm4detail8}}
                                                <br class="d-block d-sm-none"> {{language.funddetailthm4detail9}}
                                            </th>
                                            <th>{{language.funddetailthm4detail10}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of Tab4PDF">
                                            <td>{{item.Ticker}}</td>
                                            <td>{{item.Unit| number}}</td>
                                            <td>{{item.Result| number: '1.2'}}</td>
                                        </tr>

                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td><span class="h6">Total</span></td>
                                            <td><span class="h2 star">{{Tab4Total | number: '1.2'}}</span></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div *ngIf="isTDEX" class="note">
                                <ul class="list list-unstyled list-star">
                                    <li>{{language.funddetailthm4detail11}}</li>
                                </ul>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>

    </div>
</section>

<!-- perModal -->
<div class="modal fade" id="perModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-card--container">
                <button type="button" class="close--button close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                        <i class="icon-close"></i>
                    </span>
                </button>
                <h4 class="modal-title" id="calModalLabel">
                    <div class="border-circle">
                        <img src="assets/images/icon/ic-barchart-blue@2x.png" alt="icon" />
                    </div>
                    <span class="text">Performance Report</span>
                </h4>
                <div class="modal--body">
                    <table class="table table--fund -credit table-striped table-hover">
                        <thead>
                            <tr>
                                <th width="10%">NO.</th>
                                <th width="50%" class="text-left">Portfolio</th>
                                <th width="40%">{{investPeriod}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1.</td>
                                <td class="text-left">{{investPortfolioCode}}</td>
                                <td>{{investBenchmark}}%</td>
                            </tr>
                            <tr>
                                <td>2.</td>
                                <td class="text-left">{{investSd}}</td>
                                <td>{{investSDBenchmark}}%</td>
                            </tr>
                            <tr *ngFor="let dpr of dataPerformanceReports">
                                <td>{{dpr['index']}}.</td>
                                <td class="text-left">{{dpr['value']}}</td>
                                <td>{{dpr['percent']}}%</td>
                            </tr>
                        </tbody>
                    </table>
                    <section class="footer-remark">
                        <header>
                            <h5 class="topic-title">Note</h5>
                        </header>

                        <div class="info">
                            <p *ngFor="let item of investNoteTitle">{{item['index']}}.
                                <span>{{item['noteTitle']}}</span>
                                <br> {{item['noteDetail']}}
                            </p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- sumModal -->
<div class="modal fade" id="sumModal" tabindex="-1" role="dialog" aria-labelledby="perforModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-card--container">
                <button type="button" class="close--button close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                        <i class="icon-close"></i>
                    </span>
                </button>
                <h4 class="modal-title" id="calModalLabel">
                    <div class="border-circle">
                        <img src="assets/images/icon/ic-cal-blue@2x.png" alt="icon" />
                    </div>
                    <span class="text">Performance Calculation</span>
                </h4>
                <div class="modal--body">
                    <section class="wrapper-modal">
                        <!-- table 1 -->
                        <section class="group-table">
                            <table class="table table--fund -credit table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th>NO.</th>
                                        <th class="text-left">Portfolio</th>
                                        <th>YTD</th>
                                        <th>3M</th>
                                        <th>6M</th>
                                        <th>1Y</th>
                                        <th>3Y</th>
                                        <th>5Y</th>
                                        <th>10Y</th>
                                        <th>Since <br> Inception</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td class="text-left">{{portPerformance[0]}}</td>
                                        <td>{{portPerformance[1]}}%</td>
                                        <td>{{portPerformance[2]}}%</td>
                                        <td>{{portPerformance[3]}}%</td>
                                        <td>{{portPerformance[4]}}%</td>
                                        <td>{{portPerformance[5]}}%</td>
                                        <td>{{portPerformance[6]}}%</td>
                                        <td>{{portPerformance[7]}}%</td>
                                        <td>{{portPerformance[8]}}%</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td class="text-left">{{portSDPerformance[0]}}</td>
                                        <td>{{portSDPerformance[1]}}%</td>
                                        <td>{{portSDPerformance[2]}}%</td>
                                        <td>{{portSDPerformance[3]}}%</td>
                                        <td>{{portSDPerformance[4]}}%</td>
                                        <td>{{portSDPerformance[5]}}%</td>
                                        <td>{{portSDPerformance[6]}}%</td>
                                        <td>{{portSDPerformance[7]}}%</td>
                                        <td>{{portSDPerformance[8]}}%</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td class="text-left">{{portBenchmarkPerformance[0]}}</td>
                                        <td>{{portBenchmarkPerformance[1]}}%</td>
                                        <td>{{portBenchmarkPerformance[2]}}%</td>
                                        <td>{{portBenchmarkPerformance[3]}}%</td>
                                        <td>{{portBenchmarkPerformance[4]}}%</td>
                                        <td>{{portBenchmarkPerformance[5]}}%</td>
                                        <td>{{portBenchmarkPerformance[6]}}%</td>
                                        <td>{{portBenchmarkPerformance[7]}}%</td>
                                        <td>{{portBenchmarkPerformance[8]}}%</td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td class="text-left">{{portSDBenchmarkPerformance[0]}}</td>
                                        <td>{{portSDBenchmarkPerformance[1]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[2]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[3]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[4]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[5]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[6]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[7]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[8]}}%</td>
                                    </tr>
                                </tbody>
                            </table>
                            <section class="footer-remark">
                                <header>
                                    <h5 class="topic-title">Note</h5>
                                </header>

                                <div class="info">
                                    <p *ngFor="let item of portPerfNote">{{item['index']}}. {{item['noteTitle']}}<br>
                                        {{item['noteDetail']}} </p>
                                </div>
                            </section>
                        </section>

                        <!-- table 2 -->
                        <section class="group-table" style="margin-top: 40px;">
                            <table class="table table--fund -credit table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th class="text-left">ปี</th>
                                        <th>{{returnPerfYear[0]}}</th>
                                        <th>{{returnPerfYear[1]}}</th>
                                        <th>{{returnPerfYear[2]}}</th>
                                        <th>{{returnPerfYear[3]}}</th>
                                        <th>{{returnPerfYear[4]}}</th>
                                        <th>{{returnPerfYear[5]}}</th>
                                        <th>{{returnPerfYear[6]}}</th>
                                        <th>{{returnPerfYear[7]}}</th>
                                        <th>{{returnPerfYear[8]}}</th>
                                        <th>{{returnPerfYear[9]}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left">{{returnPortPerf[0]}}</td>
                                        <td>{{returnPortPerf[1]}}%</td>
                                        <td>{{returnPortPerf[2]}}%</td>
                                        <td>{{returnPortPerf[3]}}%</td>
                                        <td>{{returnPortPerf[4]}}%</td>
                                        <td>{{returnPortPerf[5]}}%</td>
                                        <td>{{returnPortPerf[6]}}%</td>
                                        <td>{{returnPortPerf[7]}}%</td>
                                        <td>{{returnPortPerf[8]}}%</td>
                                        <td>{{returnPortPerf[9]}}%</td>
                                        <td>{{returnPortPerf[10]}}%</td>
                                    </tr>
                                    <tr>
                                        <td class="text-left">{{returnPortSDPerf[0]}}</td>
                                        <td>{{returnPortSDPerf[1]}}%</td>
                                        <td>{{returnPortSDPerf[2]}}%</td>
                                        <td>{{returnPortSDPerf[3]}}%</td>
                                        <td>{{returnPortSDPerf[4]}}%</td>
                                        <td>{{returnPortSDPerf[5]}}%</td>
                                        <td>{{returnPortSDPerf[6]}}%</td>
                                        <td>{{returnPortSDPerf[7]}}%</td>
                                        <td>{{returnPortSDPerf[8]}}%</td>
                                        <td>{{returnPortSDPerf[9]}}%</td>
                                        <td>{{returnPortSDPerf[10]}}%</td>
                                    </tr>
                                    <tr>
                                        <td class="text-left">{{returnPortBenchmark[0]}}</td>
                                        <td>{{returnPortBenchmark[1]}}%</td>
                                        <td>{{returnPortBenchmark[2]}}%</td>
                                        <td>{{returnPortBenchmark[3]}}%</td>
                                        <td>{{returnPortBenchmark[4]}}%</td>
                                        <td>{{returnPortBenchmark[5]}}%</td>
                                        <td>{{returnPortBenchmark[6]}}%</td>
                                        <td>{{returnPortBenchmark[7]}}%</td>
                                        <td>{{returnPortBenchmark[8]}}%</td>
                                        <td>{{returnPortBenchmark[9]}}%</td>
                                        <td>{{returnPortBenchmark[10]}}%</td>
                                    </tr>
                                    <tr>
                                        <td class="text-left">{{returnPortSDBenchmark[0]}}</td>
                                        <td>{{returnPortSDBenchmark[1]}}%</td>
                                        <td>{{returnPortSDBenchmark[2]}}%</td>
                                        <td>{{returnPortSDBenchmark[3]}}%</td>
                                        <td>{{returnPortSDBenchmark[4]}}%</td>
                                        <td>{{returnPortSDBenchmark[5]}}%</td>
                                        <td>{{returnPortSDBenchmark[6]}}%</td>
                                        <td>{{returnPortSDBenchmark[7]}}%</td>
                                        <td>{{returnPortSDBenchmark[8]}}%</td>
                                        <td>{{returnPortSDBenchmark[9]}}%</td>
                                        <td>{{returnPortSDBenchmark[10]}}%</td>
                                    </tr>
                                </tbody>
                            </table>
                            <section class="footer-remark">
                                <header>
                                    <h5 class="topic-title">{{language.funddetailthsummodal1}}</h5>
                                </header>
                                <div class="info">
                                    <ol class="list-number">
                                        <li>{{language.funddetailthsummodal2}}
                                        </li>
                                        <li>{{language.funddetailthsummodal3}}
                                        </li>
                                        <li>
                                            <span class="text-danger">{{language.funddetailthsummodal4}}</span>
                                        </li>
                                        <li>{{language.funddetailthsummodal5}}</li>
                                        <li>{{language.funddetailthsummodal6}}</li>
                                        <li>{{language.funddetailthsummodal7}}</li>
                                        <li>{{language.funddetailthsummodal8}}
                                        </li>
                                    </ol>
                                </div>
                            </section>
                        </section>
                    </section>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>